const OPEN_MENU = 'scratch-gui/menus/OPEN_MENU';
const CLOSE_MENU = 'scratch-gui/menus/CLOSE_MENU';

const MENU_ACCOUNT = 'accountMenu';
const MENU_FILE = 'fileMenu';
const MENU_EDIT = 'editMenu';
const MENU_LANGUAGE = 'languageMenu';
const MENU_LOGIN = 'loginMenu';
const MENU_ISCREATEFILE = 'isCreateFile';
const IS_BTN_HIDE = 'isbtnhide';
const SHOW_TITLE = "showtitle";
const STORM_OS_LINK = "showlink";
const LINK_TAB = "link_tab";

const MODIFLY = "modifly";
const SAVE_FILE_PATH = "save_file_path";
const SET_MODIFLY = "set_modifly";
const SET_SAVE_FILE_PATH = "set_save_file_path";

const PYTHON_MODIFLY = "python_modifly";
const SAVE_PYTHON_PATH = "save_python_path";
const SET_PYTHON_MODIFLY = "set_python_modifly";
const SET_SAVE_PYTHON_PATH = "set_save_python_path";

const initialState = {
    [MENU_ACCOUNT]: false,
    [MENU_FILE]: false,
    [MENU_EDIT]: false,
    [MENU_LANGUAGE]: false,
    [MENU_LOGIN]: false,
    [MENU_ISCREATEFILE]: true,
    [IS_BTN_HIDE]: false,
    [SHOW_TITLE]: true,
    [STORM_OS_LINK]: false,
    [LINK_TAB]: false,
    [MODIFLY]: false,
    [SAVE_FILE_PATH]: null,
    [PYTHON_MODIFLY]: false,
    [SAVE_PYTHON_PATH]: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case OPEN_MENU:
            return Object.assign({}, state, {
                [action.menu]: true
            });
        case CLOSE_MENU:
            return Object.assign({}, state, {
                [action.menu]: false
            });
        case SET_MODIFLY:
            return Object.assign({}, state, {
                [MODIFLY]: action.value
            });
        case SET_SAVE_FILE_PATH:
            return Object.assign({}, state, {
                [SAVE_FILE_PATH]: action.value
            });
        case SET_PYTHON_MODIFLY:
            return Object.assign({}, state, {
                [PYTHON_MODIFLY]: action.value
            });
        case SET_SAVE_PYTHON_PATH:
            return Object.assign({}, state, {
                [SAVE_PYTHON_PATH]: action.value
            });
        default:
            return state;
    }
};
const openMenu = menu => ({
    type: OPEN_MENU,
    menu: menu
});
const closeMenu = menu => ({
    type: CLOSE_MENU,
    menu: menu
});
const openAccountMenu = () => openMenu(MENU_ACCOUNT);
const closeAccountMenu = () => closeMenu(MENU_ACCOUNT);
const accountMenuOpen = state => state.scratchGui.menus[MENU_ACCOUNT];
const openFileMenu = () => openMenu(MENU_FILE);
const closeFileMenu = () => closeMenu(MENU_FILE);
const fileMenuOpen = state => state.scratchGui.menus[MENU_FILE];
const openEditMenu = () => openMenu(MENU_EDIT);
const closeEditMenu = () => closeMenu(MENU_EDIT);
const editMenuOpen = state => state.scratchGui.menus[MENU_EDIT];
const openLanguageMenu = () => openMenu(MENU_LANGUAGE);
const closeLanguageMenu = () => closeMenu(MENU_LANGUAGE);
const languageMenuOpen = state => state.scratchGui.menus[MENU_LANGUAGE];
const openLoginMenu = () => openMenu(MENU_LOGIN);
const closeLoginMenu = () => closeMenu(MENU_LOGIN);
const loginMenuOpen = state => state.scratchGui.menus[MENU_LOGIN];
const StormOSLinkOpen = () => openMenu(STORM_OS_LINK);
const StormOSLinkClose = () => closeMenu(STORM_OS_LINK);
const LinkTabOpen = () => openMenu(LINK_TAB);
const LinkTabClose = () => closeMenu(LINK_TAB);

const btnHideTrue = () => openMenu(IS_BTN_HIDE)
const btnHideFalse = () => closeMenu(IS_BTN_HIDE)
const closeCreateFile = () => closeMenu(MENU_ISCREATEFILE);
const openCreateFile = () => openMenu(MENU_ISCREATEFILE);

const openShowTitle = () => openMenu(SHOW_TITLE);
const closeShowTitle = () => closeMenu(SHOW_TITLE);

const setModifly = (status)=>{
    return {
        type: SET_MODIFLY,
        value:status
    }
}
const setSaveFilePath = (path)=>{
    return {
        type: SET_SAVE_FILE_PATH,
        value:path
    }
}

const setPythonModifly = (status)=>{
    return {
        type: SET_PYTHON_MODIFLY,
        value:status
    }
}
const setSavePythonPath = (path)=>{
    return {
        type: SET_SAVE_PYTHON_PATH,
        value:path
    }
}

export {
    reducer as
    default,
    initialState as menuInitialState,
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    openLanguageMenu,
    closeLanguageMenu,
    languageMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    closeCreateFile,
    openCreateFile,
    btnHideTrue,
    btnHideFalse,
    openShowTitle,
    closeShowTitle,
    StormOSLinkOpen,
    StormOSLinkClose,
    LinkTabOpen,
    LinkTabClose,
    setModifly,
    setSaveFilePath,
    setPythonModifly,
    setSavePythonPath
};
